<div class="alert alert-danger text-center" role="alert" *ngIf="isCustomerCreditBlocked" translate>CREDIT_BLOCKED</div>
<lib-filter-list #cartList [configService]="salesCartConfigService"></lib-filter-list>
